export class ApiError extends Error {
	status: number;
	code: string;
	fieldErrors?: Record<string, string[]>;
	constructor(status: number, code: string, message: string, fieldErrors?: Record<string, string[]>) {
		super(message); this.status = status; this.code = code; this.fieldErrors = fieldErrors;
	}
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
	const headers = new Headers(init.headers);
	if (init.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
	const response = await fetch(path, { ...init, headers, credentials: 'include' });
	const payload = await response.json().catch(() => null) as { data?: T; error?: { code?: string; message?: string; fieldErrors?: Record<string, string[]> } } | null;
	if (!response.ok || !payload?.data) throw new ApiError(response.status, payload?.error?.code ?? 'REQUEST_FAILED', payload?.error?.message ?? 'Не удалось выполнить запрос.', payload?.error?.fieldErrors);
	return payload.data;
}

export async function authRequest<T>(path: string, body?: unknown, turnstileToken?: string): Promise<T> {
	const response = await fetch(`/api/auth${path}`, {
		method: body === undefined ? 'GET' : 'POST', credentials: 'include',
		headers: { ...(body === undefined ? {} : { 'content-type': 'application/json' }), ...(turnstileToken ? { 'x-turnstile-token': turnstileToken } : {}) },
		body: body === undefined ? undefined : JSON.stringify(body),
	});
	const payload = await response.json().catch(() => null) as T & { message?: string; code?: string };
	if (!response.ok) throw new ApiError(response.status, payload?.code ?? 'AUTH_FAILED', payload?.message ?? 'Не удалось выполнить действие.');
	return payload;
}
